import React from "react";
import { isAuthenticated } from "../localStorage/localStorage";


const PrivateRoute = ({ Component }) => {
    const auth = isAuthenticated();

    return auth ? (
        <div>
            {Component}
        </div>
    ) : (
        window.location.href = process.env.REACT_APP_PATH_FRONT + "login"
        );
};

export default PrivateRoute;